import { getTranslateDOMPositionXY } from 'dom-lib/lib/transition/translateDOMPositionXY';
var translateDOMPositionXY = getTranslateDOMPositionXY({
  enable3DTransform: true
});
export default translateDOMPositionXY;